import { createContext, useContext } from "react";
import { useDatepicker } from "@datepicker-react/hooks";

export const DatePickerContext = createContext<ReturnType<typeof useDatepicker>>(
  {} as ReturnType<typeof useDatepicker>
);
export function useDatePickerContext() {
  return useContext(DatePickerContext);
}
